import React, { useEffect, useState, useContext } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";
import StudentComparisonChart from "../../components/charts/my_charts/StudentComparisonChart";
import SaudiFacultyByProgramChart from "../../components/charts/my_charts/SaudiFacultyByProgramChart";
import NonSaudiFacultyByProgramChart from "../../components/charts/my_charts/NonSaudiFacultyByProgramChart";
import UniversityDomainComparisonChart from "../../components/charts/my_charts/UniversityDomainComparisonChart";
// import StudentComparisonChart from "../../components/charts/my_charts/StudentComparisonChart";


const Universities = () => {
  const { id, name, logo } = useParams();
  const { changeBackground } = useContext(ThemeContext);
  const [loading, setLoading] = useState(true);

  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);

  const [universityData, setUniversityData] = useState(null);


  const [programsData, setProgramsData] = useState([]);

  const [facultyData, setFacultyData] = useState([]);
  const [nonSaudiFacultyData, setNonSaudiFacultyData] = useState([]);

  const [approvedPrograms, setApprovedPrograms] = useState([]);
  const [notApprovedPrograms, setNotApprovedPrograms] = useState([]);

  const [eligibilityRequirements, setEligibilityRequirements] = useState([]);

  const [performanceStatusCount, setPerformanceStatusCount] = useState({
    exceeded : 0,
    achieved : 0,
    below_target : 0,
  });

  const fetchUniversityData = async () => {
    try {
      const res = await fetch(`https://plo.areez.co/api/university?university_id=${id}`);
      if (!res.ok) throw new Error("فشل في تحميل بيانات الجامعة");
      const data = await res.json();
      setUniversityData(data);
    } catch (err) {
      console.error("خطأ في تحميل بيانات الجامعة:", err);
    }
  };
  

  const fetchYears = async () => {
    try {
      const response = await fetch(
        "https://plo.areez.co//api/university/academic_years"
      );

      if (!response.ok) throw new Error("فشل في تحميل بيانات");
      const data = await response.json();
      setYears(data);
      setSelectedYear(data[0].id);
      setTimeout(() => {
        handleSearch(data[0].id);
      }, 0);
    } catch (error) {
      console.error("خطأ:", error);
      setYears([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchComparisonData = async (academicYearId) => {
    try {
      const res = await fetch(
        `https://plo.areez.co/api/programs/student_comparison?academic_year_id=${academicYearId}&university_id=${id}`
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات المقارنة");
      const data = await res.json();
      // setProgramsData(data);
      if (Array.isArray(data)) {
        setProgramsData(data);
      } else {
        console.warn("بيانات غير متوقعة:", data);
        setProgramsData([]);
      }
    } catch (error) {
      console.error("خطأ:", error);
      setProgramsData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchFacultyData = async (academicYearId) => {
    try {
      const res = await fetch(
        `https://plo.areez.co/api/programs/faculty/saudi?academic_year_id=${academicYearId}&university_id=${id}`
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات هيئة التدريس");
      const data = await res.json();
      setFacultyData(data);
    } catch (error) {
      console.error("خطأ:", error);
      setFacultyData([]);
    }
  };


  const fetchNonSaudiFacultyData = async (academicYearId) => {
    try {
      const res = await fetch(
        `https://plo.areez.co/api/programs/faculty/non_saudi?academic_year_id=${academicYearId}&university_id=${id}`
      );
      if (!res.ok) throw new Error("فشل في تحميل بيانات غير السعوديين");
      const data = await res.json();
      setNonSaudiFacultyData(data);
    } catch (error) {
      console.error("خطأ:", error);
      setNonSaudiFacultyData([]);
    }
  };

  const fetchApprovedPrograms = async () => {
    try {
      const res = await fetch(
        `https://plo.areez.co/api/programs/approved?university_id=${id}`
      );
      if (!res.ok) throw new Error("فشل في تحميل البرامج المعتمدة");
      const data = await res.json();
      setApprovedPrograms(data);
    } catch (error) {
      console.error("خطأ:", error);
      setApprovedPrograms([]);
    }
  };

  const fetchNotApprovedPrograms = async () => {
    try {
      const res = await fetch(
        `https://plo.areez.co/api/programs/not_approved?university_id=${id}`
      );
      if (!res.ok) throw new Error("فشل في تحميل البرامج المعتمدة");
      const data = await res.json();
      setNotApprovedPrograms(data);
    } catch (error) {
      console.error("خطأ:", error);
      setNotApprovedPrograms([]);
    }
  };


  const fetchEligibilityRequirements = async () => {
      try {
        const res = await fetch(
          `https://plo.areez.co/api/programs/eligibility?academic_year_id=${selectedYear}&university_id=${id}`
        );
        if (!res.ok) throw new Error("فشل في تحميل متطلبات الأهلية");
        const data = await res.json();
        setEligibilityRequirements(data);
      } catch (err) {
        console.error(err);
        setEligibilityRequirements([]);
      }
  };

  const fetchPerformanceStatusCount = async (academicYearId) => {
    try {
      const response = await fetch(
        `https://plo.areez.co/api/kpi/performance_status/count/university?academic_year_id=${academicYearId}&university_id=${id}`
      );
      if (!response.ok) throw new Error("فشل في تحميل البيانات");

      const data = await response.json();
      setPerformanceStatusCount({
        exceeded: data.exceeded,
    achieved: data.achieved,
    below_target: data.below_target
  
      });
    } catch (error) {
      console.error("خطأ في تحميل البيانات:", error);
      setPerformanceStatusCount({
        exceeded: 0,
        achieved: 0,
        below_target: 0
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (yearId) => {
    
    const yearToUse = yearId || selectedYear;
  if (!yearToUse) {
    alert("يرجى اختيار السنة الدراسية أولاً.");
    return;
  }
    setLoading(true);
    fetchComparisonData(yearToUse);
    fetchFacultyData(yearToUse);
    fetchNonSaudiFacultyData(yearToUse);
    fetchEligibilityRequirements(yearToUse);
    fetchPerformanceStatusCount(yearToUse);
  };

  useEffect(() => {
    fetchYears();
    fetchApprovedPrograms();
    fetchNotApprovedPrograms();
    fetchUniversityData();

    changeBackground({ value: "light", label: "Light" });
  }, [id]);

  const startedData = programsData.map((p) => p.total_started_students);
  const completedData = programsData.map((p) => p.total_completed_students);
  const programNames = programsData.map((p) => p.program_name);


  
  const handleRowClick = (programId) => {
    window.location.href = `/universities/programs/${programId}?year=${selectedYear}`;
  };

  return (
    <div className="row mt-5">
      <h3 className="mb-3 d-flex align-items-center gap-2">
      {universityData?.logo_url && (
    <img
      src={universityData.logo_url}
      alt={`شعار ${name}`}
      onError={(e) => {
        e.target.src = "/default-logo.png";
      }}
      style={{ width: "70px", height: "70px", objectFit: "contain", marginLeft: "10px" }}
    />
  )}
  {name}
  
</h3>

      <div className="col-12 mb-5">
        <div className="input-group">
          <select
            className="form-control"
            value={selectedYear || ""}
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            <option value="">اختر السنة الدراسية</option>
            {years.map((year) => (
              <option key={year.id} value={year.id}>
                {year.name}
              </option>
            ))}
          </select>
          <div className="input-group-append">
            <button
              className="btn btn-primary"
              // onClick={handleSearch}
              onClick={() => handleSearch(selectedYear)}

              disabled={loading}
            >
              <i className="fa fa-search mr-1"></i>{" "}
              {loading ? "جارٍ البحث..." : ""}
            </button>
          </div>
        </div>
      </div>

   
      <div className="col-12 col-lg-4 mb-4">
      <div className="widget-stat card bg-primary">
        <div className="card-body p-4">
          <div className="media pb-2">
            <span className="mr-3">
              <i className="fa fa-trophy  text-white"></i>
            </span>
            <div className="media-body text-white">
              <p className="mb-1">عدد المؤشرات التي تجاوزت المستهدف</p>
              <h3 className="text-white">{performanceStatusCount.exceeded || 0}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="col-12 col-lg-4 mb-4">
      <div className="widget-stat card bg-success">
        <div className="card-body p-4">
          <div className="media pb-2">
            <span className="mr-3">
              <i className="fa fa-check-circle  text-white"></i>
            </span>
            <div className="media-body text-white">
              <p className="mb-1">عدد المؤشرات التي حققت المستهدف</p>
              <h3 className="text-white">{performanceStatusCount.achieved  || 0}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="col-12 col-lg-4 mb-4">
      <div className="widget-stat card bg-warning">
        <div className="card-body p-4">
          <div className="media pb-2">
            <span className="mr-3">
              <i className="fa fa-exclamation-triangle  text-white"></i>
            </span>
            <div className="media-body text-white">
              <p className="mb-1">عدد المؤشرات التي لم تحقق المستهدف</p>
              <h3 className="text-white">{performanceStatusCount.below_target  || 0}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="col-12 col-lg-6">
      <UniversityDomainComparisonChart universityId={id} />
    </div>

      {programsData.length > 0 && (
        <div className="col12 col-lg-6">
          <StudentComparisonChart
            startedData={startedData}
            completedData={completedData}
            categories={programNames}
            title="مقارنة عدد الطلاب بين البرامج"
          />
        </div>
      )}

      {facultyData.length > 0 && (
        <div className="col-12 col-lg-6">
          <SaudiFacultyByProgramChart
            malePercentages={facultyData.map(
              (item) => item.saudi_male_percentage
            )}
            femalePercentages={facultyData.map(
              (item) => item.saudi_female_percentage
            )}
            categories={facultyData.map((item) => item.program_name)}
            title="نسبة هيئة التدريس السعوديين (ذكور وإناث) حسب البرنامج"
          />
        </div>
      )}

      {nonSaudiFacultyData.length > 0 && (
        <div className="col-12 col-lg-6">
          <NonSaudiFacultyByProgramChart
            malePercentages={nonSaudiFacultyData.map(
              (item) => item.non_saudi_male_percentage
            )}
            femalePercentages={nonSaudiFacultyData.map(
              (item) => item.non_saudi_female_percentage
            )}
            categories={nonSaudiFacultyData.map((item) => item.program_name)}
            title="نسبة هيئة التدريس غير السعوديين (ذكور وإناث) حسب البرنامج"
          />
        </div>
      )}

      <div className="col-12 col-lg-6 mt-4">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">البرامج المعتمدة في الجامعة</h5>

            {loading ? (
              <p className="text-center">جاري التحميل...</p>
            ) : approvedPrograms.length === 0 ? (
              <p className="text-center">لا توجد برامج معتمدة.</p>
            ) : (
              <Table
                responsive
                hover
                className="header-border verticle-middle text-center"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th className="text-center">رمز البرنامج</th>
                    <th className="text-center">اسم البرنامج</th>
                    <th className="text-center">الكلية</th>
                    <th className="text-center">القسم</th>
                    <th className="text-center">تاريخ الاعتماد</th>
                    <th className="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {approvedPrograms.map((program, index) => (
                    <tr key={program.program_id}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">{program.code}</td>
                      <td className="text-center">{program.name}</td>
                      <td className="text-center">{program.college}</td>
                      <td className="text-center">{program.department}</td>
                      <td className="text-center">
                        {program.approve_date
                          ? new Date(program.approve_date).toLocaleDateString(
                              "ar-EG"
                            )
                          : "—"}
                      </td>
                      <td>
                        <div className="d-flex">
                          <div>
                          <button
                              className="btn btn-sm btn-outline-primary" 
                              onClick={() => handleRowClick(program.program_id)}
                            >
                              تفاصيل
                            </button>
                          </div>
                          <a
                            href={`https://plo.areez.co/web#id=${program.program_id}&cids=5&menu_id=115&action=164&model=preparation.learning.program&view_type=form`}
                              className="btn btn-sm btn-outline-info" style={{marginRight:"10px"}}
                            >
                              مراجعة
                            </a>

                        </div>
                      
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-6 mt-4">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">البرامج غير المعتمدة في الجامعة</h5>

            {loading ? (
              <p className="text-center">جاري التحميل...</p>
            ) : notApprovedPrograms.length === 0 ? (
              <p className="text-center">لا توجد برامج غير معتمدة.</p>
            ) : (
              <Table
                responsive
                hover
                className="header-border verticle-middle text-center"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th className="text-center">رمز البرنامج</th>
                    <th className="text-center">اسم البرنامج</th>
                    <th className="text-center">الكلية</th>
                    <th className="text-center">القسم</th>
                    <th className="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {notApprovedPrograms.map((program, index) => (
                    <tr key={program.program_id}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">{program.code}</td>
                      <td className="text-center">{program.name}</td>
                      <td className="text-center">{program.college}</td>
                      <td className="text-center">{program.department}</td>
                     
                      <td>
                      <button
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => handleRowClick(program.program_id)}
                            >
                              تفاصيل
                            </button>
                            <a
                            href={`https://plo.areez.co/web#id=${program.program_id}&cids=5&menu_id=115&action=164&model=preparation.learning.program&view_type=form`}
                              className="btn btn-sm btn-outline-info" style={{marginRight:"10px"}}
                            >
                              مراجعة
                            </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        </div>
      </div>


      {eligibilityRequirements.length > 0 && (
  <div className="col-12 col-lg-6 mt-4">
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">متطلبات الأهلية للبرامج</h5>

        <Table
          responsive
          hover
          className="header-border verticle-middle text-center"
        >
          <thead>
            <tr>
              <th>#</th>
              <th className="text-center">اسم البرنامج</th>
              <th className="text-center">الكلية</th>
              <th className="text-center">السنة الأكاديمية</th>
            </tr>
          </thead>
          <tbody>
            {eligibilityRequirements.map((item, index) => (
              <tr key={item.sheet_id}>
                <td className="text-center">{index + 1}</td>
                <td className="text-center">{item.program_name}</td>
                <td className="text-center">{item.college_name}</td>
                <td className="text-center">{item.academic_year_name}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default Universities;
